import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface DialogData {
  msg: string;
  type: string;
  icon: string;
}

@Component({
  selector: 'jax-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
  }
  public open(asMsg: string, asType: string = 'info'): MatDialogRef<any> {
    const lsT: string = asType;
    // tslint:disable-next-line:max-line-length
    const lsIcon = (lsT === 'info') ? 'info' : (lsT === 'ok') ? 'done' : (lsT === 'error') ? 'cancel' : (lsT === 'warning') ? 'warning' : '';
    const dialogRef = this.dialog.open(DialogContentComponent, {
      width: '300px',
      // panelClass: 'lllxxx',
      data: { msg: asMsg, type: asType, icon: lsIcon }
    });
    return dialogRef;
  }
  public openSpinner(): MatDialogRef<any> {
    const dialogRef = this.dialog.open(DialogSpinnerComponent, {
      disableClose: true,
      panelClass: 'jax-spinner'
    });
    return dialogRef;
  }
  public closeSpinner(): void {
    try {
      this.dialog.closeAll();
    } catch (error) {
    }
  }
}

@Component({
  templateUrl: 'alert-dialog.component.html',
  styleUrls: ['alert-dialog.component.scss']
})
export class DialogContentComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogContentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    if (!this.data) {
      this.data = { msg: '', type: '', icon: '' };
    }
  }
}

@Component({
  templateUrl: 'alert-spinner.component.html',
  styleUrls: ['alert-spinner.component.scss']
})
export class DialogSpinnerComponent {
  constructor() {

  }
}
